import React, { useEffect, useRef, useState } from "react";
import menuIcon from "../assets/images/menuIcon.svg";

import searchIcon from "../assets/images/searchIcon.svg";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { logo } from "../assets//data/siteData";
import { SlBasket } from "react-icons/sl";

function NavBar(props) {
  const [sidebarOpen, setSideBarOpen] = useState(false);
  const sidebarRef = useRef(null);
  const firstFocusableRef = useRef(null);
  const lastFocusableRef = useRef(null);
  const navigate = useNavigate();
  const sidebarClass = sidebarOpen ? "sidebar open" : "sidebar";
  const { handleInputChange, searchProducts, searchTerm, collections } = props;

  const openSidebar = () => {
    setSideBarOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeSidebar = () => {
    setSideBarOpen(false);
    document.body.style.overflow = "unset";
  };

  const handleViewSidebar = () => {
    if (sidebarOpen) {
      closeSidebar();
    } else {
      openSidebar();
    }
  };

  function convertToUpperCase(text) {
    return text.toUpperCase();
  }

  const navLinkClass = ({ isActive }) =>
    isActive ? "navbar__menuTablet-item is-active" : "navbar__menuTablet-item";

  const sideLinkClass = ({ isActive }) =>
    isActive ? "sidebar__link sidebar__link--active" : "sidebar__link";

  const handleSearch = () => {
    searchProducts();
    navigate("/products-filtered");
  };

  const handleSearchKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSearch();
    }
  };

  useEffect(() => {
    if (!sidebarOpen) return;
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        closeSidebar();
        return;
      }
      if (event.key !== "Tab") return;
      const first = firstFocusableRef.current;
      const last = lastFocusableRef.current;
      if (!first || !last) return;
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [sidebarOpen]);

  return (
    <section className="navbar-wrapper">
      {sidebarOpen && (
        <div className="sidebar-backdrop" onClick={closeSidebar} />
      )}
      <section className="navbar">
        <button
          onClick={handleViewSidebar}
          className="navbar__btn"
          aria-expanded={sidebarOpen}
          aria-controls="mobile-sidebar"
        >
          <img className="navbar__logo " src={menuIcon} alt="logo" />
        </button>

        {/* *************************Mobile****************************** */}
        <div
          className={sidebarClass}
          id="mobile-sidebar"
          ref={sidebarRef}
          role="dialog"
          aria-modal="true"
        >
          <div className="sidebar__menuItem">
            <NavLink
              to="/"
              onClick={closeSidebar}
              ref={firstFocusableRef}
              className={sideLinkClass}
            >
              HOME
            </NavLink>
          </div>

          <div className="sidebar__menuItem">
            <NavLink
              to="/featured-collection/All"
              onClick={closeSidebar}
              className={sideLinkClass}
            >
              VITAMIN COLLECTIONS
            </NavLink>
            <ul className="sidebar__collections">
              {collections.map((collection) => {
                return (
                  <li onClick={closeSidebar} key={collection}>
                    <NavLink
                      to={`/featured-collection/${collection}`}
                      className={sideLinkClass}
                    >
                      {convertToUpperCase(collection)}
                    </NavLink>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="sidebar__menuItem">
            <NavLink to="/about" onClick={closeSidebar} className={sideLinkClass}>
              ABOUT US
            </NavLink>
          </div>
          <div className="sidebar__menuItem">
            <NavLink
              to="/contact-us"
              onClick={closeSidebar}
              className={sideLinkClass}
            >
              SUPPORT
            </NavLink>
            <ul className="sidebar__support">
              <li className="sidebar__item">
                <NavLink to="/faq" onClick={closeSidebar} className={sideLinkClass}>
                  FAQ
                </NavLink>
              </li>
              <li className="sidebar__item">
                <NavLink
                  to="/contact-us"
                  onClick={closeSidebar}
                  className={sideLinkClass}
                >
                  CONTACT US
                </NavLink>
              </li>
              <li className="sidebar__item">
                <NavLink
                  to="/refund"
                  onClick={closeSidebar}
                  className={sideLinkClass}
                >
                  REFUND POLICY
                </NavLink>
              </li>
              <li className="sidebar__item">
                <NavLink
                  to="/terms"
                  onClick={closeSidebar}
                  ref={lastFocusableRef}
                  className={sideLinkClass}
                >
                  TERMS OF SERVICE
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
        <Link to="/">
          <img src={logo} alt="logo" className="navbar__title" />
        </Link>
        <div className="navbar__search">
          <Link to="/cart" className="navbar__menuTablet-basket">
            <SlBasket className="navbar__menuTablet-basket" size="2em" />
          </Link>
        </div>

        {/* ***********************Tablet/Desktop********************************/}
        <div className="navbar__menuTablet">
          <div className="navbar__menuTablet-search">
            <input
              type="text"
              placeholder="Search products..."
              value={searchTerm}
              onChange={handleInputChange}
              onKeyDown={handleSearchKeyDown}
              className="navbar__menuTablet-search-input"
              id="searchTerm"
            />
            <button
              type="button"
              className="navbar__menuTablet-search-btn"
              onClick={handleSearch}
              aria-label="Search products"
            >
              <img src={searchIcon} alt="Search" />
            </button>
          </div>

          <Link to="/">
            <img
              src={logo}
              alt="logo"
              className="navbar__menuTablet-title fadeInLeft"
            />
          </Link>
          <Link to="/cart" className="navbar__menuTablet-basket">
            <SlBasket className="navbar__menuTablet-basket" size="2em" />
          </Link>
        </div>
      </section>
      <ul className="navbar__menuTablet-list fadeIn">
        <li id="navbar__menuTablet-item ">
          <NavLink to="/" className={navLinkClass}>
            HOME
          </NavLink>
        </li>

        <li id="navbar__menuTablet-item">
          <div className="dropdown">
            <NavLink to="/featured-collection/All" className={navLinkClass}>
              VITAMIN COLLECTIONS
            </NavLink>
            <div className="dropdown-content">
              {collections.map((collection) => {
                return (
                  <NavLink to={`/featured-collection/${collection}`} key={collection}>
                    {convertToUpperCase(collection)}
                  </NavLink>
                );
              })}
            </div>
          </div>
        </li>
        <li id="navbar__menuTablet-item">
          <NavLink to="/about" className={navLinkClass}>
            ABOUT US
          </NavLink>
        </li>
        <li id="navbar__menuTablet-item">
          <div className="dropdown">
            <div className="dropbtn navbar__menuTablet-item">SUPPORT</div>
            <div className="dropdown-content">
              <NavLink to="/faq">FAQ</NavLink>
              <NavLink to="/contact-us">CONTACT US</NavLink>
              <NavLink to="/refund">REFUND POLICY</NavLink>
              <NavLink to="/terms">TERMS OF SERVICE</NavLink>
            </div>
          </div>
        </li>
      </ul>
    </section>
  );
}

export default NavBar;
